import Vue from 'vue'
import configs from '@/config'

let resource = null

const actions = {
  uploadAudienceLog: {
    method: 'POST',
    url: `${configs.baseUrl}/api/upload/audience-logs`,
  },
}

const initResource = () => {
  resource = Vue.resource('', {}, actions)
}

const sendLog = async (payload, params) => {
  const res = await resource.uploadAudienceLog(params, payload)
  return res.body
}

export default {
  initResource,
  sendLog,
}
